{
  "version": 1,
  "asset_id": "d7baa3f0-bdd1-406d-acbb-5dcce11dd90a",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/d7baa3f0-bdd1-406d-acbb-5dcce11dd90a/silivri-hizli-elektrikci-7-24-dukkan-6.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/d7baa3f0-bdd1-406d-acbb-5dcce11dd90a/silivri-hizli-elektrikci-7-24-dukkan-6.jpg",
  "original_filename": "silivri-hizli-elektrikci-7-24-dukkan-6.jpg",
  "size": 153527,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:26:52Z"
}
